import { Navigate } from "react-router-dom";
import AuthService from "../Services/AuthService"
const Protected = ({ children }) => {
 if (!AuthService.IsUserLoggedIn()) {
 return <Navigate to="/login" replace />;
 }
 return children;
};
export default Protected;